import { Tab, styled } from '@mui/material';
import { CoreBox } from '@youscience/core';

export const sxStyles = {
  formName: {
    display: 'flex',
    alignSelf: 'stretch',
    flexWrap: 'nowrap',
  },
  formStatus: {
    display: 'flex',
    alignSelf: 'stretch',
    flexWrap: 'nowrap',
    color: '#BDBDBD',
  },
  tabWrap: {
    display: 'flex',
    justifyContent: 'end',
  },
};

export const StyledContent = styled(CoreBox)(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  backgroundColor: '#F9F9F9',
}));

export const StyledForm = styled(CoreBox)(() => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '2rem 5rem',
  alignItems: 'stretch',
  gap: '1.5rem',
  flex: '1 0 0',
}));

export const StyledSidenav = styled(CoreBox)(() => ({
  display: 'flex',
  width: '16.875rem',
  flexDirection: 'column',
  alignItems: 'flex-end',
  alignSelf: 'stretch',
}));

export const StyledTab = styled(Tab)(() => ({
  display: 'flex',
  alignSelf: 'stretch',
  padding: '0',
}));

export const StyledTabLabel = styled(CoreBox, { shouldForwardProp: (prop) => prop !== 'isActive' })<{
  isActive: boolean;
}>(({ isActive, theme }) => ({
  display: 'flex',
  padding: '0.875rem 1.125rem',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '0.75rem',

  '& > div > span': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },

  '& > div > p': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    fontWeight: 'bold',
  },

  '> svg': {
    fill: isActive ? theme.palette.secondary.main : 'inherit',
    color: isActive ? theme.palette.secondary.main : 'inherit',
  },
}));
